import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Body as CoreBody } from '@vds-core/typography';
import BAUConfig from './config';
import { Fonts } from '../../fonts';

var Body = function Body(props) {
  function getBodyFontWeight(typescale, bold) {
    switch (typescale) {
      case 'MVP':
      case 'VDS':
        return bold ? '750' : '400';
      // 400 is mapped to match 55 Roman

      default:
        return bold ? 'bold' : 'normal';
    }
  }

  return /*#__PURE__*/React.createElement(CoreBody, _extends({}, props, {
    getFontWeight: getBodyFontWeight,
    config: BAUConfig,
    fontsConfig: Fonts
  }));
};

export default Body;